export type SizeProp =
  | '2xs'
  | 'xs'
  | 'sm'
  | 'lg'
  | 'xl'
  | '2xl'
  | '1x'
  | '2x'
  | '3x'
  | '4x'
  | '5x'
  | '6x'
  | '7x'
  | '8x'
  | '9x'
  | '10x';

export enum SpriteIconsLight {
  CHEVRON_DOWN = 'fa-light-chevron-down',
  CHEVRON_LEFT = 'fa-light-chevron-left',
  CHEVRON_RIGHT = 'fa-light-chevron-right',
  CHEVRON_UP = 'fa-light-chevron-up',
  OPEN_BOOK = 'fa-light-book-open-cover',
  PEN = 'fa-light-pen',
  TRASH = 'fa-light-trash',
  TRASH_CAN = 'fa-trash-can',
  ARROW_DOWN = 'fa-light-arrow-down',
  NOTEBOOK = 'fa-light-notebook',
  USERS = 'fa-light-users',
  CIRCLE_USER = 'fa-light-circle-user',
  CLOUD_ARROW_DOWN = 'fa-light-cloud-arrow-down',
  SQUARE_ARROW_UP_LEFT = 'fa-light-square-arrow-up-left',
  XMARK = 'fa-light-xmark',
  MEMO = 'fa-light-memo',
  CIRCLE_QUESTION = 'fa-light-circle-question',
  PENCIL = 'fa-light-pencil',
  STAR = 'fa-light-star',
  INFO = 'fa-light-circle-info',
  ERROR = 'fa-light-triangle-exclamation',
  TRAJECTORY = 'fa-light-route',
  MESSAGE_QUESTION = 'fa-light-message-question',
  CLIPBOARD_CHECK = 'fa-light-clipboard-check',
  BULLSEYE_ARROW = 'fa-light-bullseye-arrow',
  USERS_VIEWFINDER = 'fa-light-users-viewfinder',
  PEOPLE_ROOF = 'fa-light-people-roof',
  PLANE_DEPARTURE = 'fa-light-plane-departure',
  ARROW_RIGHT_FROM_BRACKET = 'fa-light-arrow-right-from-bracket',
  GHOST = 'fa-light-ghost',
  EDIT = 'fa-light-pen-to-square',
  COLUMN = 'fa-light-columns',
  BACK_BUTTON = 'fa-light-chevrons-left',
  REFRESH = 'fa-light-arrows-rotate',
  PROGRESS_AND_SCORES = 'fa-light-chart-column',
  CANCEL = 'fa-light-xmark',
  NOTE = 'fa-light-notebook',
  SCIENTIFIC = 'fa-light-square-root-variable',
  GRAPHING = 'fa-light-wave-sine',
  BOOKMARK = 'fa-light-bookmark',
  FULLSCREEN_ON = 'fa-light-arrows-maximize',
  FULLSCREEN_OFF = 'fa-light-arrows-minimize',
  SOLUTIONS = 'fa-light-clipboard-check',
  PRINT = 'fa-light-print',
  SETTINGS = 'fa-light-gear',
  LOCK = 'fa-light-lock',
  UNLOCK = 'fa-light-lock-open',
  ANGLE_UP = 'fa-light-angle-up',
  ANGLE_DOWN = 'fa-light-angle-down',
  ANGLE_LEFT = 'fa-light-angle-left',
  ANGLE_RIGHT = 'fa-light-angle-right',
  CONTACT = 'fa-light-message-captions',
  USER = 'fa-light-user',
  VISIBLE = 'fa-light-eye',
  INVISIBLE = 'fa-light-eye-slash',
  PROGRESS = 'fa-light-bars-progress',
  SCORES = 'fa-light-gauge-high',
  RECENT = 'fa-light-clock-rotate-left',
  CIRCLE_CHECK = 'fa-light-circle-check',
  CIRCLE_ARROW_RIGHT = 'fa-light-circle-arrow-right',
  CIRCLE_PLUS = 'fa-light-circle-plus',
  BOOK = 'fa-light-book',
  FOCUS_GROUP = 'fa-light-users-viewfinder',
  RECTANGLE_GROUP = 'fa-light-users-rectangle',
  ROOF_GROUP = 'fa-light-people-roof',
  DELETE = 'fa-light-trash',
  CHECK = 'fa-light-check',
  COLLABORATION = 'fa-light-user-group',
  EXERCISES = 'fa-light-list',
  SUBMIT = 'fa-light-circle-arrow-right',
  THEORY = 'fa-light-align-justify',
  PLUS = 'fa-light-plus',
  FEEDBACK_TEXT = 'fa-light-message-lines',
  EYE = 'fa-light-eye',
  BRAIN = 'fa-light-brain',
  TIMER = 'fa-light-stopwatch',
  LIST = 'fa-light-list',
  COPY = 'fa-light-copy',
  LOCATION_DOT = 'fa-light-location-dot',
  LINK = 'fa-light-link',
  FILE_PEN = 'fa-light-file-pen',
  BROWSER = 'fa-light-browser',
  MAP_SIGN = 'fa-light-map-signs',
  PENNANT = 'fal fa-pennant',
  FILE = 'fa-light-file',
  PASTE = 'fa-light-paste',
  FILE_DASHED_LINE = 'fa-light-file-dashed-line',
  SORT = 'fa-light-sort',
  T_LETTER = 'fa-light-t-letter',
  TYPEWRITER = 'fa-light-typewriter',
  CODE_SIMPLE = 'fa-light-code-simple',
  GAMEPAD_MODERN = 'fa-light-gamepad-modern',
  CIRCLE_PLAY = 'fa-light-circle-play',
  ELLIPSIS = 'fa-light-ellipsis',
  LIST_TREE = 'fa-light-list-tree',
  TAGS = 'fa-light-tags',
  ARROWS_FROM_LINE = 'fa-light-arrows-from-line',
  BRACKETS_CURLY = 'fa-light-brackets-curly',
  BRACKET_CURLY = 'fa-light-bracket-curly',
  PAPER_CLIP = 'fa-light-paper-clip',
  HAND_POINT_LEFT = 'fa-light-hand-point-left',
  COMMENTS_QUESTION_CHECK = 'fa-light-comments-question-check',
  BELL = 'fa-light-bell',
  MAGNIFYING_GLASS = 'fa-magnifying-glass',
  PLAY = 'fa-play',
  STOP = 'fa-stop',
}

export enum SpriteIconsCustom {
  GEOGEBRA_CAS = 'custom-geogebra-cas',
}

export enum SpriteIconsSolid {
  MAGNIFYING_GLASS = 'fa-solid-magnifying-glass',
  CIRCLE = 'fa-solid-circle',
  CIRCLE_CHECK = 'fa-solid-circle-check',
  SOLID_ARROW_UP_RIGHT_FROM_SQUARE = 'fa-solid-arrow-up-right-from-square',
  CHEVRON_DOWN = 'fa-solid-chevron-down',
  CHEVRON_LEFT = 'fa-solid-chevron-left',
  CHEVRON_RIGHT = 'fa-solid-chevron-right',
  CHEVRON_UP = 'fa-solid-chevron-up',
  XMARK = 'fa-solid-xmark',
  SQUARE = 'fa-solid-square',
  TRASH = 'fa-solid-trash',
  EDIT = 'fa-solid-edit',
  ELLIPSIS_VERTICAL = 'fa-solid-ellipsis-vertical',
  ARROW_ROTATE_LEFT = 'fa-solid-arrow-rotate-left',
  MINUS = 'fa-solid-minus',
  PLUS = 'fa-solid-plus',
  PLUS_MINUS = 'fa-solid-plus-minus',
  STAR = 'fa-solid-star',
  PERIOD = 'fa-solid-period',
  SYNC_ALT = 'fa-sync-alt',
  CHECK = 'fa-check',
  ARROW_UP = 'fa-arrow-up',
  UMBRELLA = 'fa-umbrella',
}

export enum SpriteIconsRegular {
  SQUARE = 'fa-regular-square',
  PROGRESS_BAR = 'fa-regular-progress-bar',
  GRIP_DOTS_VERTICAL = 'fa-regular-grip-dots-vertical',
  GRIP_DOTS_HORIZONTAL = 'fa-regular-grip-dots-horizontal',
  CHEVRONS_RIGHT = 'fa-chevrons-right',
  CHEVRONS_DOWN = 'fa-chevrons-down',
  CHEVRONS_UP = 'fa-chevrons-up',
}

export type SpriteIcon =
  | SpriteIconsSolid
  | SpriteIconsLight
  | SpriteIconsRegular
  | SpriteIconsCustom;

export const SizeMap = {
  '2xs': '10px',
  xs: '12px',
  sm: '14px',
  md: '16px',
  lg: '20px',
  xl: '24px',
  '2xl': '32px',
  '1x': '1em',
  '2x': '2em',
  '3x': '3em',
  '4x': '4em',
  '5x': '5em',
  '6x': '6em',
  '7x': '7em',
  '8x': '8em',
  '9x': '9em',
  '10x': '10em',
} as const;

export type SizeMapKeys = keyof typeof SizeMap;
